import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";


export const fetchCountryData = createAsyncThunk("country/fetchData", async () => {
    try {
        const response = await api.get("/countries");
        const data = response.data.data;
        if (response.data.status == "success") {
            return data;
        }
    } catch (error) {
        return error;
    }
});
export const countrySlice = createSlice({
    name: "country",
    initialState: {
        loading: false,
        error: null,
        countries: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCountryData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCountryData.fulfilled, (state, action) => {
                state.loading = false;
                state.countries = action.payload;
            })
            .addCase(fetchCountryData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default countrySlice.reducer;